import React from 'react'

import type { PreviewMode } from 'services/Store/Project/enums'
import type { Block, IBlockMode } from 'services/Store/Project/types'

import EditorBlock from './EditorBlock'
import PreviewBlock from './PreviewBlock'
import SkeletonBlock from './SkeletonBlock'

const BLOCK_MAP: Partial<Record<PreviewMode, typeof PreviewBlock>> = {
  editor: EditorBlock,
  skeleton: SkeletonBlock,
}

interface IProps {
  mode: IBlockMode
  block?: Block | null
  index?: number
  rootRef?: React.RefObject<HTMLDivElement>
}

const BlockContainer: React.FC<IProps> = ({ block, mode, rootRef, index = 0 }) => {
  const Component = BLOCK_MAP[mode.previewMode] || PreviewBlock

  if (Array.isArray(block?.schema)) {
    return <div>Old block</div>
  }

  if (!block?.schema?.rootId) {
    return null
  }

  return <Component block={block} index={index} mode={mode} rootRef={rootRef} />
}

export default React.memo(BlockContainer)
